import React from 'react'
import { Trans } from '@lingui/macro'
import { DashboardContentPage } from 'components/containers/dashboard/DashboardContentTable'
import { CallbackList } from './callback/CallbackList';
import { POSITION_WITH_FULL_ACCESS, USERPOSITIONS } from 'constants/userPositions';
import { LanguageSettings } from 'components/containers/dashboard/dataSettings/languageSettings/languageSettings';
import { DataEps } from 'components/containers/dashboard/dataEps';
import {
    DropDownBlockWrapper
} from 'components/containers/dashboard/dataSettings/dropDownBlockWrapper/DropDownBlockWrapper';


// Type
export type typeViewDataSettings = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
    position: USERPOSITIONS | string
}
// Component
export const ViewDataSettings: React.FC<typeViewDataSettings> = (
    {
        variant,
        setSidebarOpen,
        position
    }
) => {

    return (
        <DashboardContentPage
            headerTitle={ <Trans>Settings</Trans> }
            setSidebarOpen={ setSidebarOpen }
        >

            <div className={ 'border-t border-gray-200 px-4 py-6 flex flex-col gap-8' }>
                <DropDownBlockWrapper header={ <Trans>Interface</Trans> } variant={ variant } defaultOpen={ true }>
                    <div className={ 'grid sm:grid-cols-3' }>
                        <LanguageSettings/>
                    </div>
                </DropDownBlockWrapper>

                { POSITION_WITH_FULL_ACCESS.includes(position as USERPOSITIONS) &&
                    <DropDownBlockWrapper header={ <Trans>Callbacks</Trans> } variant={ variant }>
                        <CallbackList />
                    </DropDownBlockWrapper>
                }
                {process.env.REACT_APP_EPS === 'true' && <DropDownBlockWrapper header={<Trans>Electronic payment system</Trans>} variant={variant}>
                    <DataEps variant={variant}/>
                </DropDownBlockWrapper>}
            </div>

        </DashboardContentPage>
    )
}
